'use client';

import { ExternalLink } from 'lucide-react';

export interface DetectedLink {
  type: 'youtube' | 'other';
  embedUrl?: string;
}

export function detectLink(url: string): DetectedLink {
  try {
    const ytMatch = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/
    );
    if (ytMatch) {
      return { type: 'youtube', embedUrl: `https://www.youtube.com/embed/${ytMatch[1]}` };
    }
  } catch {}
  return { type: 'other' };
}

export default function LinkPreview({ url }: { url: string }) {
  const { type, embedUrl } = detectLink(url);

  if (type === 'youtube' && embedUrl) {
    return (
      <div className="rounded-lg overflow-hidden border border-slate-700">
        <iframe
          src={embedUrl}
          className="w-full aspect-video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  let domain = '';
  try {
    domain = new URL(url).hostname;
  } catch {}

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 p-3 bg-slate-900/50 border border-slate-700 rounded-lg hover:border-slate-500 transition-colors group"
    >
      <ExternalLink className="w-4 h-4 text-blue-400 flex-shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-blue-400 group-hover:text-blue-300 text-sm font-medium truncate">
          {domain || url}
        </p>
        <p className="text-gray-500 text-xs truncate">{url}</p>
      </div>
    </a>
  );
}
